import {useMutation} from '@apollo/react-hooks';

import type {
    FormNextStepsSlackMessageDelete as FormNextStepsSlackMessageDeleteMutation,
    FormNextStepsSlackMessageDeleteVariables as FormNextStepsSlackMessageDeleteMutationVariables,
} from 'nutshell-graphql-types';

import NEXT_STEPS_SLACK_MESSAGE_DELETE from '../mutations/delete-next-steps-slack-message.graphql';

export function useDeleteNextStepsSlackMessage(): (arg1: {
    variables: FormNextStepsSlackMessageDeleteMutationVariables;
    onUpdateSuccess: (client?: any) => void;
}) => Promise<any> {
    const [deleteNextStepsSlackMessage] = useMutation<
        FormNextStepsSlackMessageDeleteMutation,
        FormNextStepsSlackMessageDeleteMutationVariables
    >(NEXT_STEPS_SLACK_MESSAGE_DELETE);

    return (input: {
        variables: FormNextStepsSlackMessageDeleteMutationVariables;
        onUpdateSuccess: (client?: any) => void;
    }) => {
        return deleteNextStepsSlackMessage({
            variables: input.variables,
            update: (proxy) => {
                input.onUpdateSuccess(proxy);
            },
        });
    };
}
